export function splitArray(
    items,
    { columns } = {
        columns: 2,
    }
) {
    const rows = [];
    let row = [];
    for (let i = 0; i < items.length; i += 1) {
        if (i && i % columns === 0) {
            rows.push(row);
            row = [];
        }
        row.push(items[i]);
    }
    if (row.length) {
        rows.push(row);
    }
    return rows;
}
